import { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronDown } from "lucide-react";

const CategoryDropdown = ({ category }) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleMainClick = () => {
        setIsOpen(false);
        // Main category button click → Send listing_category_id
        navigate(`/accommodation?listing_category_id=${category.id}`);
    };

    const handleWebCategoryClick = (e) => {
        e.preventDefault();
        setIsOpen(false);
        // Dropdown web category click → Send web_category_id
        navigate(`/accommodation?web_category_id=${category.web_category_id}`);
    };

    return (
        <div
            className="relative inline-block text-left"
            ref={dropdownRef}
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
        >
            <button
                onClick={handleMainClick}
                className="flex items-center gap-1 text-white font-semibold cursor-pointer transition whitespace-nowrap"
                aria-haspopup="true"
                aria-expanded={isOpen}
            >
                {category.category_name}
                <ChevronDown
                    className={`w-4 h-4 transition-transform ${
                        isOpen ? "rotate-180 text-[#f3a648]" : "text-white"
                    }`}
                />
            </button>

            <div
                className={`absolute left-0 mt-2 w-72 bg-primary rounded-lg shadow-lg z-50 transition-all duration-200 ease-out ${
                    isOpen ? "opacity-100 scale-100 visible" : "opacity-0 scale-95 invisible"
                }`}
            >
                <a
                    href="#"
                    onClick={handleWebCategoryClick}
                    className="block px-4 py-3 text-[#F2F1F0] hover:bg-[#f3a648] hover:text-primary transition rounded-lg"
                >
                    <div className="font-medium">{category.web_category?.name}</div>
                    {category.web_sub_category?.name && (
                        <div className="text-xs text-[#F2F1F0]/80 mt-0.5">
                            {category.web_sub_category.name}
                        </div>
                    )}
                </a>
            </div>
        </div>
    );
};

export default CategoryDropdown;
